import React, { useState, useEffect } from "react";
import { Api_Url } from "../../utils/ApiUrl";
import axios from "axios";
import { toast } from "react-toastify";

const useUserManagement = () => {
    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [adminAccess, setAdminAccess] = useState("READ");
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalCount: 0,
        limit: 10
    });

    let Apiurl = Api_Url;
    let accessToken = localStorage.getItem("accessToken");

    const handleClose = () => {
        setShow(false);
        setName("");
        setEmail("");
        setAdminAccess("READ");
    };

    const handleShow = () => setShow(true);
    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);

    const fetchUsers = async (page = 1, limit = 10, orderDirection = -1, orderField = "createdAt") => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${Apiurl}/users/get/admin?offset=${page}&limit=${limit}&orderDirection=${orderDirection}&orderField=${orderField}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );

            if (response.data.statusCode === 200) {
                setUsers(response.data.data.admins);
                setPagination({
                    currentPage: page,
                    totalPages: response.data.data.pages,
                    totalCount: response.data.data.count,
                    limit
                });
            } else {
                toast.error("Failed to fetch users");
            }
        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error(error.response?.data?.message || "Something went wrong while fetching users");
        } finally {
            setLoading(false);
        }
    };

    const addUser = async () => {
        if (!name.trim()) {
            toast.error("Name is required");
            return;
        }

        if (!email.trim()) {
            toast.error("Email is required");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error("Please enter a valid email address");
            return;
        }

        try {
            setLoading(true);
            const response = await axios.post(
                `${Apiurl}/users/create/admin`,
                {
                    name,
                    email,
                    adminAccess
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (response.data.statusCode === 201) {
                handleClose();
                handleShow1();
                fetchUsers(pagination.currentPage, pagination.limit);
                toast.success("User added successfully");
            } else {
                toast.error(response.data.message || "Failed to add user");
            }
        } catch (error) {
            console.error("Error adding user:", error);
            toast.error(error.response?.data?.message || "Something went wrong while adding user");
        } finally {
            setLoading(false);
        }
    };

    const toggleUserStatus = async (userId) => {
        try {
            setLoading(true);
            const response = await axios.patch(
                `${Apiurl}/users/toggle/admin`,
                {
                    id: userId
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (response.data.statusCode === 201) {
                fetchUsers(pagination.currentPage, pagination.limit);
                toast.success("User status updated successfully");
            } else {
                toast.error(response.data.message || "Failed to update user status");
            }
        } catch (error) {
            console.error("Error toggling user status:", error);
            toast.error(error.response?.data?.message || "Something went wrong while updating user status");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const isAddUserDisabled = !name.trim() || !email.trim() || !adminAccess || loading;

    return {
        show,
        show1,
        name,
        email,
        adminAccess,
        users,
        loading,
        pagination,
        setName,
        setEmail,
        setAdminAccess,
        handleClose,
        handleShow,
        handleClose1,
        handleShow1,
        fetchUsers,
        addUser,
        toggleUserStatus,
        isAddUserDisabled,
        setPagination
    };
};
export default useUserManagement;